import { render, staticRenderFns } from "./HistoryComponent.vue?vue&type=template&id=1316c102&scoped=true&"
import script from "./HistoryComponent.vue?vue&type=script&lang=js&"
export * from "./HistoryComponent.vue?vue&type=script&lang=js&"
import style0 from "./HistoryComponent.vue?vue&type=style&index=0&id=1316c102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1316c102",
  null
  
)

export default component.exports